var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCompleted2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97139 26.4047L18.7922 37.0766C19.287 37.6745 20.0235 38.0214 20.7995 38.0214C21.5756 38.0214 22.312 37.6745 22.8068 37.0766L43.6537 11.8557C44.5693 10.7484 44.4141 9.1047 43.3058 8.18907C42.1985 7.27345 40.5558 7.4297 39.6391 8.53803L20.7995 31.3297L13.986 23.087C13.0703 21.9787 11.4276 21.8234 10.3193 22.7391C9.21201 23.6547 9.05576 25.2974 9.97139 26.4047Z",
    fill: "#50E98D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompleted2);
export default __webpack_public_path__ + "static/media/icon_completed2.71be0a5c3e6632602bd2223f26f97dcc.svg";
export { ForwardRef as ReactComponent };